import { UserService } from '../../../data/repositories/user/user.service';
import * as i0 from "@angular/core";
import * as i1 from "../../../data/repositories/user/user.service";
var UserInfoService = /** @class */ (function () {
    function UserInfoService(userService) {
        this.userService = userService;
    }
    UserInfoService.prototype.fetchUserdata = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.userService.getUserInfo(function (res) {
                if (typeof res.is_error !== 'undefined' && res.is_error === false) {
                    _this.userData = res.api_response;
                    resolve(res.api_response);
                }
                else {
                    reject({ email: '', name: '' });
                }
            });
        });
    };
    UserInfoService.prototype.getUserData = function () {
        if (typeof this.userData !== 'undefined') {
            return Promise.resolve(this.userData);
        }
        return this.fetchUserdata();
    };
    UserInfoService.ngInjectableDef = i0.defineInjectable({ factory: function UserInfoService_Factory() { return new UserInfoService(i0.inject(i1.UserService)); }, token: UserInfoService, providedIn: "root" });
    return UserInfoService;
}());
export { UserInfoService };
